/* eslint-disable no-new */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';

// import hooks
import useAppliedFilterSlider from '@/hooks/useAppliedFilterSlider';

const Tag = ({ tag, onRemove }) => {
  const { t } = useTranslation();
  const { name } = calculateFilterColor(tag.facetValueName);
  return (
    <div className='swiper-slide'>
      <p className='bra-filterTag'>
        <button
          className='bra-filterTag__remove'
          type='button'
          onClick={() => onRemove(tag.removeQuery)}
        >
          <i className='bra-icn bra-icn__no' data-class='bra-icn__no' />
        </button>
        <span className='bra-filterTag__text'>
          {tag.facetCode === 'percentageDiscountValue'
            ? t('listing:filter.option.discount.range', {
                range: name,
              })
            : name}
        </span>
      </p>
    </div>
  );
};

Tag.propTypes = {
  tag: PropTypes.shape(),
  onRemove: PropTypes.func,
};

Tag.defaultProps = {
  tag: {},
  onRemove: null,
};

const FiltersTag = ({
  breadcrumbs,
  onRemove,
  clearAllLabel,
  onClearFilters,
}) => {
  const [wrapperRef] = useAppliedFilterSlider(breadcrumbs);

  return (
    <div
      ref={wrapperRef}
      className='bra-toolbarPlp__wrap -filtersTags swiper-container'
    >
      <div className='swiper-wrapper'>
        {breadcrumbs.map(breadcrumb => (
          <Tag
            key={breadcrumb.facetValueCode}
            tag={breadcrumb}
            onRemove={onRemove}
          />
        ))}
        {breadcrumbs.length > 0 && (
          <div className='swiper-slide'>
            <button
              className='bra-toolbarPlp__removeFilterBtn'
              type='button'
              onClick={onClearFilters}
            >
              {clearAllLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

FiltersTag.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape()),
  onRemove: PropTypes.func,
  onClearFilters: PropTypes.func.isRequired,
  clearAllLabel: PropTypes.string,
};

FiltersTag.defaultProps = {
  breadcrumbs: [],
  onRemove: null,
  clearAllLabel: 'remove all',
};

export default FiltersTag;
